export default "/images/e7228010aa6d5415066efae99887fdf7.avif";